
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "services/api"
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { CustomSwitch } from "components/common/Switch";
import { changeStatus } from "slices/hearingTypeSlice";
import { removeMultipleHearingTypes } from "slices/hearingTypeSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { usePermissions } from "layouts/Admin";
import { fetchHearingTypes } from "slices/hearingTypeSlice";
import { hearingTypeSelector } from "slices/hearingTypeSlice";
import AddHearingTypes from "components/hearingType/AddHearingType";
import { convertTimeToUTCFormatted } from "helpers/convertTimeToUTC";

const apiService = new Api();

function HearingTypesList() {
  const dispatch = useDispatch()
  const { checkPermission } = usePermissions();
  const { hearingType, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(hearingTypeSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}
  });
  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });

  React.useEffect(() => {
    dispatch(fetchHearingTypes())
  }, [])

  const handleAddLocationPopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchHearingTypes())
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const handleRemoveItems = () => {
    dispatch(removeMultipleHearingTypes({ ids: selectedItems }, submitCallback))
  }
  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(hearingType?.map((hearingType) => hearingType.id.toString()))


  }

  const handleClose = () => {
    refAddutton.current.click(); setAddForm({ show: false })
  };

  //#region TABLE HEAD 

  const renderTableHeader = React.useCallback(() => {


    const callBack = (dir, sortBy) => {

      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchHearingTypes(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }

    return (
      <tr>
        <th>
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete Hearing Types') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>
        <th >
          <TableHeaderItem
            title="Hearing type name"
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th>
          <TableHeaderItem
            title="Case type name"
            sortBy="case_type_id"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Minimum Hours"
            sortBy="minimum_hours"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Creation Date"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {checkPermission('Status Hearing Types') &&
          <th >Status</th>
        }
        {checkPermission('Edit Hearing Types') &&
          <th >Actions</th>
        }
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

  //#endregion


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return (
      hearingType?.map((hearingType, index) => (
        <HearingTypeItems hearingType={hearingType} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddLocationPopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
      ))
    )
  }, [hearingType, selectedItems]);

  //#endregion


  return (
    <ListLayout
      heading="Hearing types"
      time={true}
      title=""
      buttonTitle="Add type"
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      // TODO: change loation permission with currect keyword 
      addButtonDisabled={!checkPermission('Create Hearing Types')}
      totalPages={totalPages}
      fetchList={fetchHearingTypes}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      renderAddForm={(callback) => <AddHearingTypes item={addForm.item} show={addForm.show} onClose={handleClose} callback={callback} statusPerm={checkPermission('Status Cities')} />}
      refAddutton={refAddutton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddLocationPopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      searchPlaceholder="Search types..."
      noOfItems={total}

    >

      {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
    </ListLayout>
  )

}


const HearingTypeItems = ({
  hearingType, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState(hearingType?.status);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));

  }

  React.useEffect(() => {
    setStatus(hearingType?.status)

  }, [hearingType])

  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: '#f4f4f4' } : {};
  };
  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);
  return (
    <tr>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete Hearing Types') &&
            <label className="custom-checkbox checkbox">
              <input type="checkbox" name="select-all" data-value={hearingType.id} checked={selectedItems.includes(hearingType.id.toString())} onChange={handleChange} />
              <span className="checkmark"></span>
            </label>
          }
        </div>
      </td>
      <td style={getBackgroundStyle(status)}>
        {hearingType.name}
      </td>
      <td style={getBackgroundStyle(status)}>
        {hearingType?.case_type?.name}
      </td>
      <td style={getBackgroundStyle(status)}>
        {hearingType?.minimum_hours} Hour{hearingType?.minimum_hours?.length >1 ? 's' : ''}
      </td>
      <td style={getBackgroundStyle(status)}>
        {convertTimeToUTCFormatted(hearingType.created_at)}
      </td>
      {checkPermission('Status Hearing Types') &&
        <td style={getBackgroundStyle(status)}>
          <CustomSwitch handleChange={(status) => handleStatusChange(hearingType?.id, status)} checked={status == 1 ? true : false} />
        </td>
      }
      {checkPermission('Edit Hearing Types') &&
        <td style={getBackgroundStyle(status)}>
          <button className="table_edit" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => handleAddPopUp({ ...hearingType, status })}>Edit</button>
        </td>
      }
    </tr>
  )
}


export default HearingTypesList;
